var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChipLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 18,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 17.995,
  y: 0.005,
  fill: "#fff",
  rx: 5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.56,
  fillRule: "evenodd",
  d: "M0 5.806h10.017l.016.075c.09.423.198 1.023.27 1.73.121 1.182.137 2.625-.18 4.018H0v1.3h9.933l.01.09 3 4.981h1.114l3-4.98.007-.09H27v-1.3H16.872a11 11 0 0 1-.176-1.075c-.13-1.14-.143-2.758.292-4.75H27v-1.3H16.925L14.048 0h-1.096l-2.877 4.506H0zm11.2-.647q.046.178.105.452c.097.458.214 1.106.292 1.868.146 1.435.16 3.321-.388 5.123l2.29 3.803 2.288-3.797a8 8 0 0 1-.084-.288c-.101-.377-.22-.923-.299-1.618-.152-1.34-.155-3.231.398-5.539L13.5 1.558z",
  clipRule: "evenodd"
})));
export { SvgChipLight as ReactComponent };
export default __webpack_public_path__ + "static/media/chip-light.9a567772.svg";